export var WidgetApiServiceTypes;
(function (WidgetApiServiceTypes) {
    let SourceOfFunds;
    (function (SourceOfFunds) {
        SourceOfFunds["EMPLOYMENT_INCOME"] = "employment_income";
        SourceOfFunds["INVESTMENTS"] = "investments";
        SourceOfFunds["INHERITANCE"] = "inheritance";
        SourceOfFunds["BUSINESS_INCOME"] = "business_income";
        SourceOfFunds["SAVINGS"] = "savings";
        SourceOfFunds["FAMILY"] = "family";
    })(SourceOfFunds = WidgetApiServiceTypes.SourceOfFunds || (WidgetApiServiceTypes.SourceOfFunds = {}));
    let Status;
    (function (Status) {
        Status["CREATED"] = "created";
        Status["PENDING_APPROVAL"] = "pending_approval";
        Status["PENDING_SETTLEMENT"] = "pending_settlement";
        Status["PENDING_CONFIRMATION"] = "pending_confirmation";
        Status["PENDING_KYC"] = "pending_kyc";
        Status["PROCESS"] = "process";
        Status["PROCESSING"] = "processing";
        Status["PENDING"] = "pending";
        Status["PENDING_REFUND"] = "pending_refund";
        Status["REFUND_PROCESSING"] = "refund_processing";
        Status["COMPLETE"] = "complete";
        Status["EXPIRED"] = "expired";
        Status["FAILED"] = "failed";
        Status["DENIED"] = "denied";
        Status["REFUNDED"] = "refunded";
        Status["CANCELLED"] = "cancelled";
        Status["REFUND_FAILED"] = "refund_failed";
        Status["SETTLEMENT_PENDING"] = "settlement_pending";
        Status["SETTLEMENT_PROCESSING"] = "settlement_processing";
        Status["SETTLEMENT_COMPLETE"] = "settlement_complete";
        Status["SETTLEMENT_FAILED"] = "settlement_failed";
    })(Status = WidgetApiServiceTypes.Status || (WidgetApiServiceTypes.Status = {}));
    let MarginTypes;
    (function (MarginTypes) {
        MarginTypes["Absolute"] = "absolute";
        MarginTypes["Relative"] = "relative";
        MarginTypes["Manual"] = "manual";
    })(MarginTypes = WidgetApiServiceTypes.MarginTypes || (WidgetApiServiceTypes.MarginTypes = {}));
    let ChannelTypes;
    (function (ChannelTypes) {
        ChannelTypes["P2P"] = "p2p";
        ChannelTypes["EFT"] = "eft";
        ChannelTypes["MOMO"] = "momo";
        ChannelTypes["BANK"] = "bank";
        ChannelTypes["CARD"] = "card";
        ChannelTypes["YELLOW_CARD_PIN"] = "yellowCardPin";
    })(ChannelTypes = WidgetApiServiceTypes.ChannelTypes || (WidgetApiServiceTypes.ChannelTypes = {}));
    let PaymentMethods;
    (function (PaymentMethods) {
        PaymentMethods["MOBILE_MONEY"] = "Mobile Money";
        PaymentMethods["BANK_TRANSFER"] = "Bank Transfer";
    })(PaymentMethods = WidgetApiServiceTypes.PaymentMethods || (WidgetApiServiceTypes.PaymentMethods = {}));
    let AccountType;
    (function (AccountType) {
        AccountType["BANK"] = "bank";
        AccountType["MOMO"] = "momo";
    })(AccountType = WidgetApiServiceTypes.AccountType || (WidgetApiServiceTypes.AccountType = {}));
    let FeatureFlags;
    (function (FeatureFlags) {
        FeatureFlags["WIDGET_SELL"] = "widget_sell";
    })(FeatureFlags = WidgetApiServiceTypes.FeatureFlags || (WidgetApiServiceTypes.FeatureFlags = {}));
    // The api throws bare Error(message) strings, so the view classifies the
    // fiat settlement failures it needs distinct copy for.
    let FiatSettlementErrorReason;
    (function (FiatSettlementErrorReason) {
        FiatSettlementErrorReason["NOT_FOUND"] = "notFound";
        FiatSettlementErrorReason["EXPIRED"] = "expired";
        FiatSettlementErrorReason["INVALID_STATE"] = "invalidState";
        FiatSettlementErrorReason["UNKNOWN"] = "unknown";
    })(FiatSettlementErrorReason = WidgetApiServiceTypes.FiatSettlementErrorReason || (WidgetApiServiceTypes.FiatSettlementErrorReason = {}));
})(WidgetApiServiceTypes || (WidgetApiServiceTypes = {}));
